export const formatRecommended = (text: string) => {
  if (!text) return "";
  return text.replace(/^-/gm, "•").replace(/\n/g, "\n\n");
};
